<template>
    <modal :title="modalTitle" ref="modifyQuotationPackageModal" @save="saveQuotationPackage">
        <div class="row">
            <div class="form-group col-md-12">
                <label class="control-label">Label</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="quotationPackage.label"
                />
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-12">
                <label class="control-label">Contract Term</label>
                <v-select
                    :options="contractTerms"
                    placeholder="Select Contract Terms"
                    v-model="quotationPackage.contractTerm"
                    >
                </v-select>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-md-12">
                <label class="control-label">Billing Frequency</label>
                <v-select
                    :options="billingFrequency"
                    placeholder="Select Subscription Type"
                    v-model="quotationPackage.billingFrequency"
                    >
                </v-select>
            </div>
        </div>
        <div v-if="!pricedFromQuote" class="row">
            <div class="form-group col-md-12">
                <label class="control-label">Currency</label>
                <v-select
                    :options="currencies"
                    label="description"
                    valueProp="name"
                    placeholder="Select Currency"
                    v-model="quotationPackage.currency"
                    @input="$emit('getExchangeRate', quotationPackage.currency)"
                    >
                </v-select>
            </div>
        </div>
        <div v-if="!pricedFromQuote" class="row">
            <div class="form-group col-md-12">
                <label class="control-label">Price in {{ quotationPackage.currency }}</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="quotationPackage.priceInCurrency"
                />
            </div>
        </div>
        <div class="row" v-if="quotationPackage.currency !== 'ZAR' && !pricedFromQuote">
            <div class="form-group col-md-12">
                <label class="control-label">Exchange Rate</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="quotationPackage.exchangeRate"
                    disabled
                />
            </div>
        </div>
        <div class="row" v-if="quotationPackage.currency !== 'ZAR' && !pricedFromQuote">
            <div class="form-group col-md-12">
                <label class="control-label">Price in ZAR</label>
                <input
                    type="text"
                    class="form-control"
                    v-model="quotationPackage.priceInRands"
                    disabled
                />
            </div>
        </div>
        <div class="row" v-if="this.quotationPackage.objKey">
            <div class="form-group col-md-12">
                <label class="control-label">Expired</label>
                <v-select
                    :options="['true', 'false']"
                    v-model="expired"
                    >
                </v-select>
            </div>
        </div>
        <div class="row" v-if="pricedFromQuote">
            <div class="form-group col-md-12">
                <label class="text-warning" v-if="pricedFromQuote">Prices are determined during HALO Quotation.</label>
            </div>
        </div>

    </modal>
</template>

<script>
import Modal from '@/components/GeneralComponents/Modal';

export default {
    components: {
        Modal
    },
    props: {
        modalTitle: {
            type: String,
            required: true,
        },
        quotationPackage: {
            type: Object,
            required: true,
        },
        contractTerms: {
            type: Array,
            required: true,
        },
        billingFrequency: {
            type: Array,
            required: true,
        },
        currencies: {
            type: Array,
            required: true,
        },
        pricedFromQuote: {
            type: Boolean,
            required : true
        }
    },
    watch: {
        quotationPackage: {
            deep: true,
            handler(newLine) {
                if (newLine.priceInCurrency) {
                    if (newLine.currency !== 'ZAR') {
                        this.quotationPackage.priceInRands = this.decimalFormat(newLine.priceInCurrency * newLine.exchangeRate);
                    }

                    if (newLine.priceInCurrency && newLine.currency == 'ZAR') {
                        this.quotationPackage.priceInRands = this.decimalFormat(newLine.priceInCurrency);
                    }
                }
            },
        },
    },
    computed: {
        expired: {
            get() {
                return this.quotationPackage.expired.toString();
            },
            set(expired) {
                this.quotationPackage.expired = expired;
            },
        },
    },
    methods: {
        open: function() {
            this.$refs.modifyQuotationPackageModal.open();
        },
        saveQuotationPackage: function() {
            if (this.quotationPackage.objKey !== 0) {
                this.$emit("updateQuotationPackage", this.quotationPackage);
            } else {
                this.$emit("createQuotationPackage", this.quotationPackage);
            }
        
            this.$refs.modifyQuotationPackageModal.close();
        }
    }
    
}
</script>

<style scoped>

</style>